import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { baseFontStyle, menuItemTextStyle } from "../../tickets/tickets";

const HolidayListupload = (props) => {
  const {
    holidayDialog,
    holidayFile,
    disableSubmit,
    handleHolidaySubmit,
    handleHolidayDialogClose,
    handleHolidayFileUpload,
  } = props;
  return (
    <Dialog
      open={holidayDialog.open}
      onClose={handleHolidayDialogClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          ...baseFontStyle,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Upload Holiday List
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <input
            accept=".xlsx,.xls"
            type="file"
            onChange={handleHolidayFileUpload}
          />

          {holidayFile && (
            <Typography sx={{ mt: 2 }}>{holidayFile.name}</Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleHolidayDialogClose}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={!disableSubmit}
          onClick={handleHolidaySubmit}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HolidayListupload;
